module.exports = __webpack_public_path__ + "static/media/logo-main-white.9c251793.svg";